import { map, times, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import DesktopSwatchListPlaceholder from './DesktopSwatchListPlaceholder';
import OverviewPlaceholder from './OverviewPlaceholder';
import Section from './Section';

const nPlaceholders = 2;
const PdpProductDesktopSelector = class extends React.Component {
  renderPlaceholder(i) {
    return (
      <div className="PdpProductDesktopSelector__section-placeholder" key={i}>
        <OverviewPlaceholder />
        <DesktopSwatchListPlaceholder />
      </div>
    );
  }

  renderSection(productList, label) {
    const { ...otherProps } = this.props;
    const exampleProduct = get(productList, '0');

    return (
      <Section
        {...otherProps}
        price={exampleProduct.formattedPrice}
        compareAtPrice={exampleProduct.formattedCompareAtPrice}
        label={label}
        products={productList}
        key={label}
      />
    );
  }

  render() {
    const { products, isLoading } = this.props;

    return (
      <div className="PdpProductDesktopSelector">
        {isLoading
          ? times(nPlaceholders, i => this.renderPlaceholder(i))
          : map(products, (productList, label) => this.renderSection(productList, label))}
      </div>
    );
  }
};

PdpProductDesktopSelector.propTypes = {
  isLoading: PropTypes.bool,
  products: PropTypes.shape({}),
  onSelect: PropTypes.func.isRequired,
  currentProductEdition: PropTypes.string,
  currentProductName: PropTypes.string,
  currentProductHandle: PropTypes.string,
  isSalePdp: PropTypes.bool.isRequired,
};

PdpProductDesktopSelector.defaultProps = {
  isLoading: false,
  products: {},
  currentProductEdition: null,
  currentProductName: null,
  currentProductHandle: null,
};

export default PdpProductDesktopSelector;
